<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>TRẢ LỜI</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form v-bind="this.$attrs" ref="form">
          <v-textarea
            label="nội dung"
            v-model="content"
            outlined
            required
            :rules="[$rules.required]"
            class="required"
            rows="3"
          ></v-textarea>
          <v-file-input
            v-model="files"
            show-size
            outlined
            multiple
            counter
            dense
            label="Chọn file tải lên tại đây"
            append-icon="mdi-upload"
            prepend-icon=""
            :clearable="false"
          ></v-file-input>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    state: Boolean,
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
    data: {
      immediate: true,
      handler(newData) {
        if (newData) {
          this.setFormValues(newData)
        }
      },
    },
  },
  computed: {
    ...mapGetters('auth', ['user']),
  },
  data() {
    return {
      dialog: false,
      loading: false,
      content: '',
      files: null,
    }
  },
  methods: {
    ...mapActions('upload', ['uploadFile']),
    ...mapActions('ticketMessage', ['createStudentTicketMessage']),

    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          this.$loading.active = true
          let data = {
            content: this.content,
            ticket: this.$route.params.id,
            data: [],
          }

          if (this.files && this.files.length > 0) {
            const filePromises = this.files.map((file) => {
              const formData = new FormData()
              formData.append('files', file)
              formData.append('refId', this.$route.params.id)
              formData.append('field', 'attachment')
              return this.uploadFiles(formData)
            })

            const responses = await Promise.all(filePromises)
            const uploadedFiles = responses.flat().map((response) => ({
              title: response.name,
              url: response.url,
            }))

            data.data = uploadedFiles
          }
          await this.createStudentTicketMessage({ ...data })

          this.$emit('refresh')
          this.resetForm()
          this.close()
        } catch (e) {
          this.$alert.error('Lỗi cập nhật ticket')
          console.error(e)
        } finally {
          this.$loading.active = false
        }
      }
    },
    async uploadFiles(formData) {
      return this.uploadFile(formData)
    },
    resetForm() {
      this.content = ''
      this.files = null
      this.$refs.form.resetValidation()
    },
    setFormValues(data) {
      this.content = data.content || ''
      this.files = data.files
    },
  },
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
